// extracted by mini-css-extract-plugin
export default {"title":"PropFeatureList_title__sSRLr","feature":"PropFeatureList_feature__6+18y"};